export default "__VITE_ASSET__42ca0a01__"